import React from "react";
import {
  FaFlask,
  FaBook,
  FaLaptop,
  FaFutbol,
  FaMusic,
  FaUtensils,
  FaUserShield,
  FaLeaf,
} from "react-icons/fa";

const FacilitiesSection = () => {
  const facilities = [
    {
      icon: <FaFlask className="w-5 h-5" />,
      title: "Science Labs",
      count: "Well-Equipped Labs",
      desc: "Physics, Chemistry, Biology with modern equipment",
      color: "text-blue-600 bg-blue-50",
    },
    {
      icon: <FaBook className="w-5 h-5" />,
      title: "Library",
      count: "Extensive Collection",
      desc: "Digital resources & reading zone",
      color: "text-purple-600 bg-purple-50",
    },
    {
      icon: <FaLaptop className="w-5 h-5" />,
      title: "Computer Lab",
      count: "Advanced Systems",
      desc: "High-speed internet & latest software",
      color: "text-indigo-600 bg-indigo-50",
    },
    {
      icon: <FaFutbol className="w-5 h-5" />,
      title: "Sports Facilities",
      count: "Multiple Sports Options",
      desc: "Indoor & outdoor games",
      color: "text-emerald-600 bg-emerald-50",
    },
    {
      icon: <FaMusic className="w-5 h-5" />,
      title: "Art & Music",
      count: "Creative Studios",
      desc: "Art, music, dance studios",
      color: "text-amber-600 bg-amber-50",
    },
    {
      icon: <FaUtensils className="w-5 h-5" />,
      title: "Cafeteria",
      count: "Healthy & Hygienic",
      desc: "Nutritious meals & dining area",
      color: "text-rose-600 bg-rose-50",
    },
    {
      icon: <FaUserShield className="w-5 h-5" />,
      title: "Medical Room",
      count: "On-Campus Care",
      desc: "Trained nurse & first aid",
      color: "text-red-600 bg-red-50",
    },
    {
      icon: <FaLeaf className="w-5 h-5" />,
      title: "Green Spaces",
      count: "Spacious Campus",
      desc: "Gardens & playgrounds",
      color: "text-green-600 bg-green-50",
    },
  ];

  return (
    <section className="py-8 bg-white">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto mb-8 text-center">
          <div className="inline-flex items-center px-3 py-1 mb-3 text-xs font-medium rounded-full text-emerald-600 bg-emerald-50">
            <FaLeaf className="w-3 h-3 mr-1.5" />
            Campus Facilities
          </div>
          <h2 className="mb-3 text-2xl font-bold text-gray-900">
            Modern Infrastructure
          </h2>
          <p className="text-sm text-gray-600">
            State-of-the-art facilities for comprehensive learning experience
          </p>
        </div>

        {/* Facilities Grid */}
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {facilities.map((facility, index) => (
            <div
              key={index}
              className="p-4 transition-all duration-300 bg-white border border-gray-100 group rounded-xl hover:shadow-sm"
            >
              <div
                className={`inline-flex items-center justify-center w-10 h-10 mb-3 rounded-lg ${
                  facility.color.split(" ")[1]
                }`}
              >
                <div className={facility.color.split(" ")[0]}>
                  {facility.icon}
                </div>
              </div>

              <div>
                <h3 className="mb-1 text-sm font-bold text-gray-900">
                  {facility.title}
                </h3>
                <div className="mb-2 text-xs font-medium text-gray-700">
                  {facility.count}
                </div>
                <p className="text-xs text-gray-600">{facility.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FacilitiesSection;
